var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.eventos.length === 0,
                          expression: "eventos.length === 0"
                        }
                      ]
                    },
                    [_vm._m(2)]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.eventos, function(evento, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            evento.tipo_ambiente !== null
                              ? evento.tipo_ambiente.descripcion
                              : "-"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(evento.fecha))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(evento.respuesta))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(evento.tipo))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(evento.informacion_adicional))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(evento.identificador))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(evento.estado))])
                    ])
                  })
                ],
                2
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("span", [_vm._v("Eventos de autorización")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo de ambiente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Respuesta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo de evento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Información adicional")]),
        _vm._v(" "),
        _c("th", [_vm._v("Identificador")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("strong", [_vm._v("No se encontró eventos.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10b5c95f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b5c95f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/EventosComprobante.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-10b5c95f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/EventosComprobante.vue
// module chunks = 0